module.exports = __webpack_public_path__ + "img/account.44857d53.svg";